export default __webpack_public_path__ + "static/media/instagram.50dfad9d.svg";